import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { MagicSpellView } from '@Selectors/ninthage/view/MagicSpellView';
import { Col, Row } from 'reactstrap';
import Repeater from '@Utils/Repeater';
import {
  Carousel,
  SpellCard,
} from '@Components/MagicSpellComponent/MagicSpellComponent.styled';

interface IMagicSpellComponentProps {
  spell: MagicSpellView;
  carousel: boolean;
}

const MagicSpellComponent: React.FC<MagicSpellComponentProps> = ({
  spell,
  carousel,
}) => {
  const content = (
    <>
      <div className="spellName">
        <img src={spell.pathLogo} height={70} />
        <h2>{spell.pathName}</h2>
      </div>
      <Row>
        <Col xs={3}>{spell.typeLvl}</Col>
        <Col xs={9} className='text-start'>
          {spell.name}
        </Col>
      </Row>
      <hr />
      <Row>
        <Col xs={2}>{spell.castingValue}</Col>
        <Col xs={5}>
          <ul className='list-unstyled'>
            <Repeater data={spell.targets} indexPrefix="target">
              {(item: string) => (
                <li>
                  <small>{item}</small>
                </li>
              )}
            </Repeater>
          </ul>
        </Col>
        <Col xs={5}>{spell.duration}</Col>
      </Row>
      <hr />
      <div className='p-2'>{spell.effect}</div>
    </>
  );

  if (carousel) {
    return (
      <Carousel className={`m-2 text-center`}>
        <SpellCard>{content}</SpellCard>
      </Carousel>
    );
  }

  return (
    <SpellCard className={`col-12 col-md-4 col-lg-3 col-xl-2 m-2 text-center`}>
      {content}
    </SpellCard>
  );
};

const mapStateToProps = (
  state: AppState,
  props: IMagicSpellComponentProps,
) => ({
  spell: props.spell,
  carousel: props.carousel,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MagicSpellComponent);

type MagicSpellComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
